<template>
  <div style="margin-top: 20px">
    <img
      :src="this.baseUrl + 'img/self-l.png'"
      :position="absolute"
      @click="toggleCollapse"
    />
    <el-aside :width="isCollapsed ? '0px' : '300px'">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        background-color="#111217"
        text-color="#fff"
        active-text-color="#409EFF"
        :collapse-transition="false"
        :collapse="isCollapsed"
        router
      >
        <el-menu-item index="welcome">
          <template slot="title">
            <i class="el-icon-document"></i>
            <span>主页</span>
          </template>
        </el-menu-item>
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-setting"></i>
            <span>TOPO</span>
          </template>
          <el-menu-item-group class="sub_title" title="机房信息">
            <el-menu-item index="DC_ZH_5F">
              <i class="el-icon-caret-right"></i>
              <span>门诊综合楼5F中心机房</span>
            </el-menu-item>
            <el-menu-item index="DC_HQ_5F">
              <i class="el-icon-caret-right"></i>
              <span>综合楼5F冗灾机房</span>
            </el-menu-item>
            <el-menu-item index="DC_ZH_3F">
              <i class="el-icon-caret-right"></i>
              <span>住院楼①3F汇聚机房</span>
            </el-menu-item>
            <el-menu-item index="DC_ZY_3">
              <i class="el-icon-caret-right"></i>
              <span>住院楼③1F汇聚机房</span>
            </el-menu-item>
            <el-menu-item index="DC_GR_1F">
              <i class="el-icon-caret-right"></i>
              <span>感染楼1F汇聚机房</span>
            </el-menu-item>
            <el-menu-item index="DC_ZH_1F">
              <i class="el-icon-caret-right"></i>
              <span>住院楼②1F物联网机房</span>
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group title="网络拓扑">
            <el-menu-item index="Network_all">
              <i class="el-icon-caret-right"></i>
              <span>网络图</span>
            </el-menu-item>
            <el-menu-item index="APP1">
              <i class="el-icon-caret-right"></i>
              <span>业务系统1</span>
            </el-menu-item>
            <el-menu-item index="APP2">
              <i class="el-icon-caret-right"></i>
              <span>业务系统2</span>
            </el-menu-item>
            <el-menu-item index="APP3">
              <i class="el-icon-caret-right"></i>
              <span>业务系统3</span>
            </el-menu-item>
            <el-menu-item index="Server_Stor">
              <i class="el-icon-caret-right"></i>
              <span>业务系统4</span>
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group title="机房动环">
            <el-menu-item index="DC_env_all">
              <i class="el-icon-caret-right"></i>
              <span>机房整体动环</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="/">
          <template slot="title">
            <i class="el-icon-document"></i>
            <span @click="logonOut('loginForm')">退出</span>
          </template>
        </el-menu-item>
      </el-menu>
    </el-aside>
  </div>
</template>
  
  <script>
import { Url } from "../config/env";
export default {
  data() {
    return {
      isCollapsed: true,
      baseUrl: Url,
    };
  },
  components: {},
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    logonOut() {
      sessionStorage.setItem("logon", 0);
      this.$message({
        type: "success",
        message: "退出成功",
      });
      this.$router.push("/");
    },
  },
};
</script>
  <style lang="less" scoped>
@import "../style/common";
@import "../style/mixin";
.el-aside {
  display: flex;
  flex-direction: column;
  background-color: #111217;
  // > .aside-logo {
  // > img {
  // width: 100%;
  position: absolute;
  // left: 50%;
  // margin-left: -30px;
  // }
  // }
}
.el-menu {
  height: 100%;
  border-right: none;
  // z-index: 10;
}
//一级菜单样式
.el-submenu /deep/ .el-submenu__title {
  span {
    font-size: 20px;
  }
}
.el-menu-item {
  span {
    font-size: 18px;
  }
}
//二级菜单标题样式
.el-menu-item-group /deep/ .el-menu-item-group__title {
  font-size: 18px;
}
//二级菜单样式
.el-menu-item-group /deep/ .el-menu-item {
  font-size: 18px;
}
.el-menu-item {
  color: #fff;
}
.toggleCollapse {
  // position: absolute;
  // top: 20px;
  background-color: #111217;
  color: #fff;
  font-size: 22px;
  line-height: 24px;
  text-align: right;
}
</style>
  